import BulletList from '@tiptap/extension-bullet-list';

/**
 * Extends the default BulletList extension to support a `listStyleType` attribute
 * (`disc`, `circle`, `square`) that persists via inline `style` on the `<ul>`.
 */
const CustomBulletList = BulletList.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      listStyleType: {
        default: null,
        parseHTML: (element: HTMLElement) =>
          element.style.listStyleType || null,
        renderHTML: (attributes: Record<string, any>) => {
          if (!attributes.listStyleType) return {};
          return { style: `list-style-type: ${attributes.listStyleType}` };
        },
      },
    };
  },
});

export default CustomBulletList;
